import { createAuthClient } from "better-auth/react";

export const LAST_AUTHENTICATED_USER_KEY = "excali:last-authenticated-user";
export const FORCE_GUEST_MODE_KEY = "excali:force-guest-mode";

export const authURL =
  import.meta.env.VITE_APP_AUTH_URL ||
  import.meta.env.VITE_APP_STORAGE_BACKEND_URL?.replace(/\/api\/v2\/?$/, "") ||
  "http://localhost:8787";

export const authClient = createAuthClient({
  baseURL: authURL,
});
